
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"887d3218edbdb7b8511f700dd4dfb0a375e43dcd":"generateCsvMapping"} */ export var generateCsvMapping = createServerReference("887d3218edbdb7b8511f700dd4dfb0a375e43dcd");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

